import { axiosClient as axios } from './axiosClient';

import {
  failureResult,
  ResultViewModel,
  successResult,
} from '@models/common/ResultViewModel';
import {
  PaymentResultViewModel,
  PaymentTableResultViewModel,
  PaymentViewModel,
} from '@models/Payment';
import { handleAxiosError } from '@utils/axiosErrorHandler';
import { getDataUrl } from '@utils/dataUrls';
import { api } from 'src/config/apiEndpoints';

export const PaymentService = {
  create: async function (
    payment: PaymentViewModel
  ): Promise<PaymentResultViewModel | ResultViewModel> {
    const createUrl = `${api.BASE_URL}${api.PAYMENTS_ENDPOINT}`;

    try {
      const response = await axios.post(createUrl, payment);
      return response.data as PaymentResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getList: async function (
    page?: number,
    pageSize?: number,
    searchFields?: string,
    search?: string,
    filters?: string,
    sortBy?: string,
    sortDirection?: string
  ): Promise<PaymentTableResultViewModel | ResultViewModel> {
    let dataUrl = getDataUrl(
      api.BASE_URL,
      api.PAYMENTS_ENDPOINT,
      page,
      pageSize,
      searchFields,
      search,
      sortBy,
      sortDirection
    );
    if (filters) {
      dataUrl = dataUrl + filters;
    }

    try {
      const response = await axios.get(dataUrl);
      return response.data as PaymentTableResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  getById: async function (
    id: number
  ): Promise<PaymentResultViewModel | ResultViewModel> {
    const dataUrl = `${api.BASE_URL}${api.PAYMENTS_ENDPOINT}/${id}`;

    try {
      const response = await axios.get(dataUrl);
      return response.data as PaymentResultViewModel;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  update: async function (
    id: number,
    payment: PaymentViewModel
  ): Promise<ResultViewModel> {
    const updateUrl = `${api.BASE_URL}${api.PAYMENTS_ENDPOINT}/${id}`;

    try {
      const response = await axios.put(updateUrl, payment);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
  delete: async function (id: number): Promise<ResultViewModel> {
    const deleteURL = `${api.BASE_URL}${api.PAYMENTS_ENDPOINT}/${id}`;

    try {
      const response = await axios.delete(deleteURL);
      if (response.status === 204) {
        return successResult;
      }

      return failureResult;
    } catch (error) {
      return handleAxiosError(error);
    }
  },
};
